import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltInlineCommentsSectionSortingDropdownContentItemWireframe from './VeltInlineCommentsSectionSortingDropdownContentItemWireframe/VeltInlineCommentsSectionSortingDropdownContentItemWireframe';
var VeltInlineCommentsSectionSortingDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltInlineCommentsSectionSortingDropdownContentWireframe.Item = VeltInlineCommentsSectionSortingDropdownContentItemWireframe;
export default VeltInlineCommentsSectionSortingDropdownContentWireframe;
